<template>
  <div id="app" class="mobileApp" :class="languageClass">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      document.querySelector('#app').classList.add('mobileApp')
    } else {
      if (document.querySelector('#app').classList.contains('mobileApp')) {
        document.querySelector('#app').classList.remove('mobileApp')
      }
    }
  },
  computed: {
    languageClass () {
      return this.$i18n.locale === 'zh' ? 'lang-zh' : 'lang-en'
    }
  }
}
</script>

<style lang="less">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 1.44rem;
}
.mobileApp {
  padding-top: 1.28rem !important;
  overflow: hidden;
}
.lang-en {
  font-family: 'Inter', sans-serif;
}

.lang-zh {
  font-family: 'HarmonyOS Sans SC', sans-serif;
}
</style>
